//used only on updated details page right now
// tiny slider documentation https://github.com/ganlanyuan/tiny-slider

var prodScroller = function () {  
	var tinySlider, tabSlider,
	initSlider = function(sid){
		var container = document.getElementById(sid),
		slider = container.querySelector('.Scroller');
		if(slider){
			tinySlider = new tns({
				container: slider,
				mouseDrag: true,
				lazyload: true,
				prevButton: container.querySelector('.slider-prev'),
				nextButton: container.querySelector('.slider-next'),
				items: 2,
				gutter: 20,
				slideBy: "page",
				nav:false,
				loop: false,
				responsive: {
					1024:{
						items: 5
					},
					800: {
						items: 4
					},
					480: {
						items: 3
					}
				}
			});
		}
		return tinySlider; 
	},
	initSliderLessItems = function(sid){
		var container = document.getElementById(sid),
		slider = container.querySelector('.Scroller');
		if(slider){
			tabSlider = new tns({
				container: slider,
				mouseDrag: true,
				lazyload: true,
				prevButton: container.querySelector('.slider-prev'),
				nextButton: container.querySelector('.slider-next'),
				items: 1,
				gutter: 20,
				slideBy: "page",
				nav:false,
				loop: false,
				responsive: {
					1024:{
						items: 5
					},
					800: {
						items: 4
					},
					480: {
						items: 3
					}
				}
			});
			return tabSlider; 
		}
	};
	return{
        	InitSlider: initSlider,
        	InitSliderLessItems: initSliderLessItems
	};
};